import { render, staticRenderFns } from "./job-details-form.component.vue?vue&type=template&id=31b965b5"
import script from "./job-details-form.component.ts?vue&type=script&lang=ts&external"
export * from "./job-details-form.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31b965b5')) {
      api.createRecord('31b965b5', component.options)
    } else {
      api.reload('31b965b5', component.options)
    }
    module.hot.accept("./job-details-form.component.vue?vue&type=template&id=31b965b5", function () {
      api.rerender('31b965b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/job-setup/job-details/job-details-form/job-details-form.component.vue"
export default component.exports